<div class="flex items-center justify-center gap-3 flex-col">
  <p class="font-app-bold">{{ "modal.contactAltima" | translate }}</p>
  <p class="px-4 py-2 rounded-md bg-primary text-white text-2xl shadow-md">
    {{ "modal.contactAltimaNumber" | translate }}
  </p>
</div>
